module.exports = __webpack_public_path__ + "static/media/02-06.03256955.png";